import React from 'react';

import { ReactComponent as RemoveIcon } from '../../../assets/icons/filter-close.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter.svg';
import { ReactComponent as GridIcon } from '../../../assets/icons/grid-list.svg';
import { ReactComponent as SettingsIcon } from '../../../assets/icons/setting-icon.svg';
import MyButton from '../../../shared-components/button/Button';
import CustomPopover from '../../../shared-components/custom-pop-over/CustomPopover';
import DurationToggle from '../../../shared-components/duration-toggle/DurationToggle';

import DashboardFilter from './DashboardFilter';

interface DashboardToolbarProperties {
  onCustomize?: () => void;
  toggleList: { label: string; key: string; isActive: boolean }[];
  handleClickFunction: (key: string) => void;
  onApply?: (filters: {
    facilityIds: string[];
    stationIds: string[];
    deviceIds: string[];
    type: string[];
  }) => void;
  onClear?: () => void;
  filters?: {
    facilityIds: string[];
    stationIds: string[];
    deviceIds: string[];
    type: string[];
  };
}

/**
 * DashboardToolbar component
 * Includes duration toggle and action buttons (Customize, Filter, Settings)
 */
function DashboardToolbar({ onCustomize, toggleList, handleClickFunction, onApply, onClear, filters }: DashboardToolbarProperties) {
  const hasActiveFilters = filters && (
    filters.facilityIds.length > 0 ||
    filters.stationIds.length > 0 ||
    filters.deviceIds.length > 0
  );

  return (
    <div className="dashboard-toolbar-wrap">
      <div className="toolbar-left">
        <DurationToggle toggleList={toggleList} handleClickFunction={handleClickFunction} />
      </div>
      <div className="toolbar-right">
        <div className="action-btn-group">
          <MyButton
            label="Customize Dashboard"
            buttonType="outline"
            svgIcon={<GridIcon />}
            // labelColorFill="var(--primary-color)"
            svgColorFill="var(--text-color)"
            onClickFunc={() => onCustomize?.()}
          />
          {hasActiveFilters && (
            <div className="badge">
              <MyButton
                label=""
                buttonType="outline"
                svgIcon={<RemoveIcon />}
                svgColorFill="var(--text-color)"
                onClickFunc={() => onClear?.()}
              />
            </div>
          )}
          <div className="badge-wrapper">
            <CustomPopover
              clickableElement={
                <MyButton
                  label=""
                  buttonType="outline"
                  svgIcon={<FilterIcon />}
                  svgColorFill="var(--text-color)"
                  onClickFunc={() => console.log('Filter')}
                />
              }
              popOverContent={<DashboardFilter onApply={onApply} initialFilters={filters} />}
            />
          </div>
          {false && (<div className="badge">
            <MyButton
              label=""
              buttonType="outline"
              svgIcon={<SettingsIcon />}
              svgColorFill="var(--text-color)"
              onClickFunc={() => console.log('Settings')}
            />
          </div>)}
        </div>
      </div>
    </div>
  );
}

/**
 * Default props for DashboardToolbar component
 */
DashboardToolbar.defaultProps = {
  /**
   * Default props for DashboardToolbar component
   */
  onCustomize: () => { },
  /**
   * Default props for DashboardToolbar component
   */
  onApply: () => { },
  /**
   * Default props for DashboardToolbar component
   */
  onClear: () => { },
  /**
   * Default props for DashboardToolbar component
   */
  filters: undefined,
};

export default DashboardToolbar;
